import React from 'react';
import Loadable from 'react-loadable';

// Spinner
import { ContentSpinner } from '~/components/ui/layout/spinner';

// Not Found
import NotFoundPage from './not-found/index';
function Loading({ error }) {
	if (error) {
		console.error(`Error loading component`);
	} else {
		return <ContentSpinner />;
	}
}

// Homepage
const HomePage = Loadable({
	loader: () => import('./homepage/index'),
	loading: Loading,
});

// Challenges
const ChallengesPage = Loadable({
	loader: () => import('./challenges/index'),
	loading: Loading,
});
const BlogPage = Loadable({
	loader: () => import('./blog/index'),
	loading: Loading,
});
const FaqsPage = Loadable({
	loader: () => import('./faqs/index'),
	loading: Loading,
});

const ChallengesDetailsPage = Loadable({
	loader: () => import('./challenges/challenge-details'),
	loading: Loading,
});

const ChallengeDetailsStandingsTable = Loadable({
	loader: () => import('./challenges/challenge-standings-table'),
	loading: Loading,
});

// Profile
const ProfilePage = Loadable({
	loader: () => import('./profile/index'),
	loading: Loading,
});

// Login
const LoginPage = Loadable({
	loader: () => import('./login/index'),
	loading: Loading,
});
const ErrorPage = Loadable({
	loader: () => import('./login/error-page/index'),
	loading: Loading,
});

// Admin
const AdminChallengesPage = Loadable({
	loader: () => import('./admin/challenges/index'),
	loading: Loading,
});
const AdminChallengeDetailsPage = Loadable({
	loader: () => import('./admin/challenges/admin-challenge-details'),
	loading: Loading,
});
const AdminNewChallenge = Loadable({
	loader: () => import('./admin/challenges/new-challenges/index'),
	loading: Loading,
});

export {
	HomePage,
	ChallengesPage,
	BlogPage,
	FaqsPage,
	ChallengesDetailsPage,
	ChallengeDetailsStandingsTable,
	ProfilePage,
	LoginPage,
	ErrorPage,
	AdminChallengesPage,
	AdminChallengeDetailsPage,
	AdminNewChallenge,
	NotFoundPage,
};



// WEBPACK FOOTER //
// ./src/pages/index.js